// import React from 'react';

// const packagesData = [
//   {
//     image: "images/rooms&price/luxsurypackage.jpeg",
//     title: "Day Package Information",
//     price: [
//       {
//         label: "Friday, Saturday, Sunday & All Public Holiday",
//         adult: "Rs. 3000/-Adult",
//         children: "Rs. 1500/- Children"
//       },
      
//     ],
//     features: [
//       "AC Luxurious Accommodation",
//       "Breakfast, Lunch, High-Tea and Dinner (Veg/Non-veg Unlimited)",
//       "Fruit Basket",
//       "Chaat Basket",
//       "Soft Drinks",
//       "Bath Kits",
//       "Indoor/Outdoor Activities",
//       "Swimming",
//       "Riding",
//       "Indoor/Outdoor Activities",
//       "Return Gifts"
//     ],
//   },
//   {
//     image: "images/rooms&price/daypackage (1).jpeg",
//     title: "Day Night Package Information",
//     price: [
//       {
//         label: "Friday, Saturday, Sunday & All Public Holiday",
//         adult: "Rs. 1000/-Adult",
//         children: "Rs. 500/- Children"
//       },
      
//     ],
//     features: [
//       "Breakfast, Lunch and High-Tea (Veg/Non-veg Unlimited)",
//       "Indoor/Outdoor Activities",
//       "Swimming",
//       "Adventure Trekking"
//     ],
//   },
//   {
//     image: "images/rooms&price/nightpackage.jpg",
//     title: "Night Package (Half)",
//     price: [
//       {
//         label: "Friday, Saturday, Sunday & All Public Holiday",
//         adult: "Rs. 1800/-Adult",
//         children: "Rs. 900/- Children"
//       },
     
//     ],
 


//     features: [
//       "AC Luxurious Accommodation",
//       "Breakfast, Lunch, High-Tea and Dinner (Veg/Non-veg Unlimited)",
//       "Fruit Basket",
//       "Chaat Basket",
//       "Soft Drinks",
//       "Bath Kits",
//       "Indoor/Outdoor Activities",
//       "Swimming",
//       "Riding",
//       "Indoor/Outdoor Activities",
//       "Return Gifts",
//       "Adventure Trekking"
//     ],
//   }
// ];

// const PackageCard = ({ packageData }) => {
//   return (
//    <>
    

//     <div className="package-card">
//       <img src={packageData.image} alt="Resort" className="package-img" />
//       <h3>{packageData.title}</h3>

//       {packageData.price.map((price, index) => (
//         <div key={index} className="price-section">
//           <h4>
//             {price.adult} / {price.children}
       
//             <p>{price.label}</p>
//             <p>{price.time}</p>
//           </h4>
//         </div>
//       ))}

//       <ul className="package-features">
//         {packageData.features.map((feature, index) => (
//           <li key={index}>{feature}</li>
//         ))}
//       </ul>

//       <a href="/booking" className="book-now">Book Now</a>
//     </div>
   
//    </>
//   );
// };

// const PackagesSection = () => {
//   return (

//    <>


      //    <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
      //   <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
      //   <div className="breadcrumb-outer">
      //     <div className="container">
      //       <div className="breadcrumb-content text-center">
      //         <h2 className="mb-3 text-white">Packages</h2>
      //       </div>
      //     </div>
      //   </div>
      //   <div className="dot-overlay"></div>
      // </section>



      
//     <div className="packages-container">
//       {packagesData.map((packageData, index) => (
//         <PackageCard key={index} packageData={packageData} />
//       ))}
//     </div>
   
//    </>
//   );
// };

// export default PackagesSection;









import React from 'react';

const packagesData = [
  {
    title: "Day Package Information",
    time: "9.30 AM to 6 PM",
    charges: "Adult: ₹650 (p/p), Children (4 to 10 years): ₹300 (p/child), Below 4 Years: No Charges",
    breakfast: "9.30 AM to 11.00 AM",
    lunch: "2.00 PM to 3.30 PM",
    highTea: "5.00 PM to 6.00 PM",
    activities: [
      "Swimming Pool", "Rain Dance", "Shivar Safari", "Boating", "DJ Music",
      "Magic Show", "Puppet Show", "Bullock Cart Ride", "Tractor Ride",
      "Horse Riding", "Adventure Games", "Cricket", "Volleyball", "Badminton",
      "Indoor Games", "Kids Playing Area", "Traditional Games", "Peacock Watching"
    ],
    color: "#4CAF50", // Green
    whatsappNumber: "919689125047",
  },
  {
    title: "Day Night Package Information",
    time: "9.30 AM to 6 PM",
    charges: "Adult: ₹1500 (p/p), Children (4 to 10 years): ₹700 (p/child), Below 4 Years: No Charges",
    breakfast: "9.30 AM to 11.00 AM",
    lunch: "2.00 PM to 3.30 PM",
    highTea: "5.00 PM to 6.00 PM",
    dinner: "7.30 PM to 9.00 PM",
    activities: [
      "Swimming Pool", "Rain Dance", "Shivar Safari", "Boating", "DJ Music",
      "Magic Show", "Puppet Show", "Bullock Cart Ride", "Tractor Ride",
      "Horse Riding", "Adventure Games", "Cricket", "Volleyball", "Badminton",
      "Indoor Games", "Kids Playing Area", "Traditional Games", "Peacock Watching"
    ],
    color: "#FFEB3B", // Yellow
    whatsappNumber: "919689125047",
  },
  {
    title: "School Picnic Package",
    time: "9.30 AM to 5.30 PM",
    // charges: "Students: ₹400 (p/child), Teachers: ₹700 (p/person)",
    charges: "Students: Jr. & Sr. KG Students-₹250/, \n  Std. 1st to 5th Students – ₹350/-,\n Std. 6th to 8th Students – ₹400/-",
    breakfast: "9.30 AM to 11.00 AM",
    lunch: "1.00 PM to 2.30 PM",
    highTea: "4.00 PM to 5.00 PM",
    activities: [
      "Magic Show", "Puppet Show", "Bullock Cart Ride", "Tractor Ride", "Horse Riding",
      "Rain Dance", "Swimming Pool", "DJ Music", "Peacock Watching", "Kids Games Zone",
      "Adventure Games", "Rope Activities", "Traditional Village Games"
    ],
    color: "#2196F3", // Blue
    whatsappNumber: "919689125047",
  }
];

const PackageCard = ({ data }) => {
  const whatsappLink = `https://wa.me/${data.whatsappNumber}?text=I'm%20interested%20in%20the%20${encodeURIComponent(data.title)}.`;

  return (
    <div className="package-card" style={{ borderTop: `6px solid ${data.color}` }}>
      <div className="package-header" style={{ backgroundColor: data.color }}>
        <h3>{data.title}</h3>
      </div>
      <div className="package-body">
        <p><strong>Time:</strong> {data.time}</p>
        <p><strong>Charges:</strong> {data.charges}</p>
        <p><strong>Breakfast:</strong> {data.breakfast}</p>
        {data.lunch && <p><strong>Lunch:</strong> {data.lunch}</p>}
        {data.highTea && <p><strong>High Tea:</strong> {data.highTea}</p>}
        {data.dinner && <p><strong>Dinner:</strong> {data.dinner}</p>}

        <p><strong>Activities:</strong></p>
        <ul>
          {data.activities.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>

        <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="buy-now-btn">
          Buy Plan
        </a>
      </div>
    </div>
  );
};

const PackagesSection = () => {
  return (


<>
       <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
        <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
        <div className="breadcrumb-outer">
          <div className="container">
            <div className="breadcrumb-content text-center">
              <h2 className="mb-3 text-white">Packages</h2>
            </div>
          </div>
        </div>
        <div className="dot-overlay"></div>
      </section>
      
    <section className="packages-section">
      <div className="packages-container">
        {packagesData.map((pkg, index) => (
          <PackageCard key={index} data={pkg} />
        ))}
      </div>
    </section>


</>
  );
};

export default PackagesSection;
